import styled from 'styled-components';

export const ThresholdFields = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 360px;
`;

// The toggles are a separate group, so they sit clearly below the thresholds
export const ToggleSection = styled.div`
    margin-top: 32px;
`;
